<template>
	<section class="quote">
		<div class="copy" v-html="copy"></div>
		<span class="author" v-html="author"></span>
	</section>
</template>

<script>
export default {
	props: {
		copy: String,
		author: String,
	},
};
</script>

<style lang="scss" scoped>
.copy {
	@include moduleSpacing;
	@include fontH0;
	width: 100%;
	position: relative;

	&:before {
		position: absolute;
		top: 0;
		left: 0;
		transform: translate(-120%, -5px);
		content: "«";
	}

	&::v-deep p:last-child {
		&:after {
			content: "»";
		}
	}

	&::v-deep * {
		@include fontH0;

		em {
			line-height: 1.5;
			display: inline;
			background: $colorRed1;
			border-radius: 3px;
			box-shadow: 10px 0 0 $colorRed1, -5px 0 0 $colorRed1;
		}
	}

	@include mq($from: m) {
		@include gridColumn(m, 18, 4, false, true);
	}

	@include mq($from: xl) {
		@include gridColumn(xl, 14, 4, false, true);
	}
}

.author {
	@include fontCopy;
	display: block;
	width: 100%;
	margin-top: 10px;

	&:before {
		content: "- ";
	}

	&::v-deep * {
		@include fontCopy;
	}

	@include mq($from: m) {
		@include gridColumn(m, 18, 4, false, true);
	}

	@include mq($from: xl) {
		@include gridColumn(xl, 14, 4, false, true);
		margin-top: 20px;
	}
}
</style>
